import { SxProps, Theme } from '@mui/material/styles';

export const styles: Record<string, SxProps<Theme>> = {
  headerBar: { display: 'flex', alignItems: 'center', px: 3, pt: 3, pb: 2 },
  title: { flex: 1, fontSize: 22, color: '#232323', fontWeight: 700 },
  searchWrap: { width: 260, display: 'flex', justifyContent: 'flex-end' },
  searchInput: {
    background: '#F7F7FA',
    borderRadius: 2,
    px: 2,
    py: 1.1,
    fontSize: 15,
    fontWeight: 500,
    color: '#232323',
    boxShadow: 'none',
    border: '1px solid #F0F0F0',
  },
  tableContainer: { px: 3, background: '#fff', overflowX: 'auto' },
  table: { minWidth: 600 },
  headerRow: { background: '#F5F6FA' },
  headerCell: { fontWeight: 600, fontSize: 14, color: '#232323', py: 1.2, borderBottom: 'none' },
  rowCell: { py: 1.5, fontSize: 14, color: '#232323', borderBottom: 'none' },
  interactiveRow: {
    borderBottom: '1px solid #F0F0F0',
    '&:last-child td': { borderBottom: 'none' },
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': { background: '#F5F6FA' },
  },
  footerBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, pb: 2, pt: 1 },
  footerText: { color: '#888', fontSize: 13 },
  pagination: { '& .MuiPaginationItem-root': { fontWeight: 500 } },
};

// Checkbox custom icon styles
export const AutoCompleteDropDownIcon: React.CSSProperties = {
  border: '0.125rem solid #ccc',
  borderRadius: '0.375rem',
  width: '1.25rem',
  height: '1.25rem',
  display: 'block',
};

export const AutoCompleteDropDowncheckedIcon: React.CSSProperties = {
  background: '#EAF7EA',
  borderRadius: '0.375rem',
  width: '1.25rem',
  height: '1.25rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#4CAF50',
  padding: '0.125rem',
};

export const FilterIconSx={ width: '43px', height: '43px', cursor: 'pointer' };